/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov, Leonid Khramov
 */
import React, { Component } from 'react'
import { roughTimeEstimate } from '../../../util/formatter'
import './VideoProgress.css'

/*
 * Props
 *
 * uploads
 * cancelUpload
 */

export default class VideoProgress extends Component {

    constructor() {
        super()
        this.cancelUpload = this.cancelUpload.bind(this)
    }

    cancelUpload(e) {
        e.preventDefault()
        var upload = this.props.uploads[e.currentTarget.id]
        if (upload) {
            this.props.cancelUpload(upload)
        }
    }

    render() {
        var keys = Object.keys(this.props.uploads)
        var items = keys.map((key) => {
            var upload = this.props.uploads[key]
            var percent = Math.floor(upload.uploaded * 100)
            var progressText = `${percent}%`
            if (percent <= 0) {
                progressText = 'Pending'
            }
            else if (percent === 100 || upload.success) {
                progressText = 'Upload Complete'
            }
            var timeText = ''
            if (upload.timeRemaining) {
                timeText = ` ${roughTimeEstimate(upload.timeRemaining)} left`
            }
            var uploadCN = ''
            if (upload.error) {
                uploadCN = 'failed'
            } else if (percent > 0 && percent < 100) {
                uploadCN += ' active'
            }

            return (
                <li key={upload.key} className={ uploadCN }>
                    <div className="filename">{upload.file}</div>
                    { upload.error && (
                        <div className="percent">Upload Failed: try uploading this file again.</div>
                    )}
                    { ! upload.error && (
                        <div className="percent">{progressText}</div>
                    )}
                    { ! upload.error && (
                        <div className="time">{timeText}</div>
                    )}
                    <div className="progress" style={ {width: `${percent}%`} }></div>
                    <a id={upload.key} href="#cancel" className="cancel" onClick={this.cancelUpload}>&nbsp;</a>
                </li>
            )
        })

        var styles = {}
        if (this.props.show === false) {
            styles = { display: 'none' }
        }

        return (
            <div style={styles} className="VideoProgress">
                <ul>
                    { items }
                </ul>
            </div>
        )
    }

}
